<template>
  <div class="l-container">
    <div
      v-if="$scopedSlots['header']"
      class="l-header"
      data-testid="ppm-modal-header"
    >
      <slot name="header" />
    </div>

    <div class="l-main">
      <div v-if="$scopedSlots['image']" class="l-img">
        <slot name="image" />
      </div>

      <slot name="default" />
    </div>

    <Footer v-if="$scopedSlots['footer']">
      <slot name="footer" />
    </Footer>

    <VerticalFooter v-if="$scopedSlots['vertical-footer']">
      <slot name="vertical-footer" />
    </VerticalFooter>
  </div>
</template>

<script>
import Footer from './Footer.vue'
import VerticalFooter from './VerticalFooter.vue'

export default {
  components: {
    Footer,
    VerticalFooter,
  },
}
</script>

<style lang="postcss" scoped>
.l-container {
  /* Base */
  @apply tw-flex tw-flex-col tw-bg-white tw-rounded-lg tw-min-h-[464px];

  /* Desktop */
  @apply lg:tw-min-h-0;
}

.l-header {
  /* Base */
  @apply tw-flex tw-flex-col tw-items-center tw-mt-6 tw-mx-6;
}

.l-main {
  /* Base */
  @apply tw-flex tw-flex-col tw-flex-1 tw-mx-6;

  /* Tablet */
  @apply md:tw-max-w-[640px] md:tw-self-center md:tw-items-center;
  /* Desktop */
  @apply lg:tw-max-w-[712px] lg:tw-self-center lg:tw-items-center;
}

.l-img {
  /* Base */
  @apply tw-flex tw-flex-col tw-items-center tw-my-7;
}

.l-img >>> img {
  @apply tw-w-[230px] tw-h-[232px] tw-object-contain;
  @apply lg:tw-w-[258px] lg:tw-h-[260px];
}
</style>
